import React, { useEffect, useState } from 'react'
import {
  Table,
  Input,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Select,
  Upload,
} from 'antd'
import {
  PlusOutlined,
  UploadOutlined,
  DeleteOutlined,
  CameraOutlined,
} from '@ant-design/icons'
import { toast } from 'react-toastify'
import axiosInstance from '../../Utils/axiosInstance'

import {
  UpdatePhotoUpdateData,
  GetPhotoUpdateData,
  DeletePhotoUpdateData,
  GetUserTypeData,
  GetLifeTimeMemberData,
} from "../../API's/AdminApi"

const { Option } = Select

export default function PhotoUpdate() {
  const [data, setData] = useState([])
  const [members, setMembers] = useState([])

  const [showForm, setShowForm] = useState(false)
  const [deleteId, setDeleteId] = useState(null)

  const [submitted, setSubmitted] = useState(false)

  const [tableLoading, setTableLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [previewImage, setPreviewImage] = useState('')
  const [fileList, setFileList] = useState([])

  const [form] = Form.useForm()

  // ---------------- GET MEMBERS ----------------
  const getMembers = async () => {
    try {
      const res = await axiosInstance.get(`${GetLifeTimeMemberData}`)
      setMembers(res.data || [])
    } catch {
      toast.error('Failed to load members')
    }
  }

  useEffect(() => {
    getMembers()
  }, [])

  // ---------------- FORM SUBMIT ----------------
  const onFinish = async (values) => {
    try {
      setSubmitLoading(true)

      const formData = new FormData()
      formData.append('id', values.member)
      formData.append('photo', fileList[0].originFileObj)

      const res = await axiosInstance.put(UpdatePhotoUpdateData, formData)

      if (res.data === 'UPDATED') {
        toast.success('Photo uploaded successfully')
      }

      form.resetFields()
      setFileList([])
      setPreviewImage('')
      setShowForm(false)
    } catch (error) {
      toast.error('Upload failed')
    } finally {
      setSubmitLoading(false)
    }
  }

  return (
    <div>
      <div className="row p-0 m-0">
        <div className="col-12 col-md-1 col-lg-2"></div>
        <div className="col-12 col-md-10 col-lg-8 page-background1 p-2 p-md-4">
          {/* HEADER */}
          <div className="page-header">
            <h2>
              <CameraOutlined style={{ marginRight: 8 }} />
              Photo Update
            </h2>
          </div>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={() => setSubmitted(true)}
          >
            <Row gutter={16}>
              <Col xs={24} md={12}>
                {/* MEMBER */}
                <Form.Item
                  label="Member"
                  name="member"
                  rules={[{ required: true, message: 'Member is required' }]}
                >
                  <Select placeholder="Select Member">
                    {members.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                {/* PHOTO UPLOAD */}
                <Form.Item
                  label="Upload Photo"
                  name="photo"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) return e
                    return e?.fileList
                  }}
                  rules={[{ required: true, message: 'Photo is required' }]}
                >
                  <Upload
                    beforeUpload={(file) => {
                      const isValidType =
                        file.type === 'image/jpeg' ||
                        file.type === 'image/jpg' ||
                        file.type === 'image/png'

                      if (!isValidType) {
                        toast.error('Only JPG, JPEG, PNG files allowed')
                        return Upload.LIST_IGNORE
                      }

                      const isLt3MB = file.size / 1024 / 1024 < 3

                      if (!isLt3MB) {
                        toast.error('Image must be smaller than 3MB')
                        return Upload.LIST_IGNORE
                      }

                      const reader = new FileReader()
                      reader.readAsDataURL(file)
                      reader.onload = () => {
                        setPreviewImage(reader.result)
                      }

                      setFileList([
                        {
                          uid: file.uid,
                          name: file.name,
                          status: 'done',
                          originFileObj: file,
                        },
                      ])

                      return false
                    }}
                    fileList={fileList}
                    onRemove={() => {
                      setFileList([])
                      setPreviewImage('')
                    }}
                    maxCount={1}
                    listType="picture"
                  >
                    <Button icon={<UploadOutlined />}>Select Photo</Button>
                  </Upload>
                </Form.Item>
              </Col>

              <Col xs={24} className='mb-3'>
                {' '}
                <span style={{color:"red"}}>
                  (This feature is available only for Monthly and Yearly
                  Memberships.)
                </span>{' '}
              </Col>
            </Row>

            {/* BUTTONS */}
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={submitLoading}>
                Submit
              </Button>

              <Button
                style={{ marginLeft: 10 }}
                onClick={() => {
                  setShowForm(false)
                  form.resetFields()
                  setPreviewImage('')
                  setFileList([])
                }}
              >
                Cancel
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className="col-12 col-md-1 col-lg-2"></div>
      </div>
    </div>
  )
}
